// extracted by mini-css-extract-plugin
export default {"Content":"PageSuiviReglements_Content__mRsIj","PartieGauche":"PageSuiviReglements_PartieGauche__QaeYU","PartieDroite":"PageSuiviReglements_PartieDroite__7Le1e"};